<template>
  <Page class="DealsPage">
    <IllustrationBanner />

    <el-button
      :style="filterTableModalTogglerStyle"
      type="primary"
      circle
      class="FilterTableModalToggler card--1 d-xl-none"
      @click="showFilterTableModal"
    >
      <i class="fas fa-filter" />
    </el-button>

    <ModalSide
      :class="{ active: filterTableModalIsVisible }"
      side="left"
      @hideModalSide="hideFilterTableModal($event)"
    >
      <DealFilterTable slot="body" />
    </ModalSide>

    <div class="DealsPage__main">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 d-none d-xl-block">
            <DealFilterTable />
          </div>

          <div class="col-xl-9">
            <DealFilterResultInfoBar :data="infoBarData" />
            <SortBy class="DealsPage__sortBy" />

            <ErrorMessage
              v-if="noResults"
              :error-type="noResults"
              style="height: auto;"
            />
            <DealList
              v-else
              :deals="sortedDeals"
            />

          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import calculationMixin from '@/mixins/calculation';
// Components
import Page from '@/components/Page.vue';
import IllustrationBanner from '@/components/IllustrationBanner.vue';
import SortBy from '@/components/SortBy.vue';
import DealFilterTable from '@/components/dealFilter/Table.vue';
import DealFilterResultInfoBar from '@/components/dealFilter/ResultInfoBar.vue';
import DealList from '@/components/deal/List.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import ModalSide from '@/components/modal/Side.vue';

export default {
  name: 'DealsPage',
  components: {
    Page,
    IllustrationBanner,
    SortBy,
    DealFilterTable,
    DealFilterResultInfoBar,
    DealList,
    ErrorMessage,
    ModalSide,
  },
  mixins: [calculationMixin],
  data() {
    return {
      filterTableModalIsVisible: false,
    };
  },
  computed: {
    allDeals() {
      return this.$store.state.deals.allDeals;
    },
    activeFilters() {
      return this.$store.state.filter.activeFilters;
    },
    activeSorts() {
      return this.$store.state.sort.activeSorts;
    },
    filteredDeals() {
      return this.allDeals.filter((deal) => {
        const hasDistributor = () => {
          if (deal.distributor) {
            return deal.distributor.id === this.activeFilters.distributor;
          } return false;
        };

        const hasCustomerType = () => (
          this.activeFilters.customerType ?
            deal.customer_type.id === this.activeFilters.customerType
            : deal
        );

        const hasMeterType = () => (
          this.activeFilters.meterType ?
            deal.meter_type === this.activeFilters.meterType
            : deal
        );

        const hasPowerMeasurement = () => (
          this.activeFilters.powerMeasurement ?
            deal.power_measurement === this.activeFilters.powerMeasurement
            : deal
        );
        console.log(deal.power_measurement);
        console.log(this.activeFilters.powerMeasurement);
        console.log(deal.power_measurement === this.activeFilters.powerMeasurement);

        const hasConsumtionType = () => {
          if (this.activeFilters.consumtionType && deal.small_consumer) {
            return deal;
          } else if (!this.activeFilters.consumtionType && !deal.small_consumer) {
            return deal;
          }
          return null;
        };

        return hasDistributor()
          && hasCustomerType()
          && hasMeterType()
          && hasPowerMeasurement()
          && hasConsumtionType(); // ovo je problem
      });
    },
    calculatedDeals() {
      return this.calculateDeals(this.activeFilters.customerType, this.filteredDeals);
    },
    modifiedDeals() {
      const arr = [];
      this.calculatedDeals.forEach(deal => arr.push(deal));

      if (this.lowestPriceDeal) {
        const index = arr.indexOf(this.lowestPriceDeal);
        arr[index].lowest = true;
      }
      return arr;
    },
    sortedDeals() {
      const { sort } = this.activeSorts;

      switch (sort) {
        case 1:
          return this.dealsByPriceLowestToHighest(this.modifiedDeals);
        case 2:
          return this.dealsByPriceHighestToLowest(this.modifiedDeals);
        default:
          return this.modifiedDeals;
      }
    },
    noResults() {
      if (this.sortedDeals.length === 0) {
        return 'noResults';
      } return '';
    },
    suppliers() {
      return this.$store.state.filter.suppliers;
    },
    lowestPriceDeal() {
      if (this.calculatedDeals.length !== 0) {
        return this.calculatedDeals.reduce((acc, cur) => {
          const accTotal = acc.calculatedData.neto;
          const curTotal = cur.calculatedData.neto;

          return accTotal < curTotal ? acc : cur;
        });
      }
      return null;
    },
    highestPriceDeal() {
      if (this.calculatedDeals.length !== 0) {
        return this.calculatedDeals.reduce((acc, cur) => {
          const accTotal = acc.calculatedData.neto;
          const curTotal = cur.calculatedData.neto;

          return accTotal > curTotal ? acc : cur;
        });
      }
      return null;
    },
    percentagePriceDiffBetweenHighAndLow() {
      if (this.highestPriceDeal && this.lowestPriceDeal) {
        const higherValue =
          this.highestPriceDeal.calculatedData.neto;
        const lowerValue =
          this.lowestPriceDeal.calculatedData.neto;

        const a = higherValue - lowerValue;
        const b = (higherValue + lowerValue) / 2;
        const result = (a / b) * 100;
        return result;
      }
      return 0;
    },
    infoBarData() {
      const numberOfSuppliers = this.suppliers.length;
      const lowestPrice = this.lowestPriceDeal
        ? this.lowestPriceDeal.calculatedData.neto
        : 0;
      const percentagePriceDiff = this.percentagePriceDiffBetweenHighAndLow;
      return {
        numberOfSuppliers,
        lowestPrice,
        percentagePriceDiff,
      };
    },
    windowSize() {
      return this.$store.state.layout.windowSize;
    },
    isScrolledToFooter() {
      return this.$store.state.layout.isScrolledToFooter;
    },
    filterTableModalTogglerStyle() {
      if (this.isScrolledToFooter) {
        return {
          position: 'absolute',
        };
      } return {};
    },
  },
  watch: {
    activeFilters: {
      handler(value) {
        console.log('customer type in store: ', value);
      },
      deep: true,
    },
    filteredDeals(value) {
      console.log('filtered deals: ', value);
    },
    calculatedDeals(value) {
      console.log('calculated deals', value);
    },
    sortedDeals: {
      handler(value) {
        console.log('sorted deals', value);
      },
    },
    windowSize: {
      deep: true,
      handler(value) {
        if (value.width >= 1200) {
          this.hideFilterTableModal(false);
        }
      },
    },
  },
  methods: {
    dealsByPriceLowestToHighest(deals) {
      return deals.slice().sort((a, b) => (
        a.calculatedData.totalAnnuallyBillPrice - b.calculatedData.totalAnnuallyBillPrice
      ));
    },
    dealsByPriceHighestToLowest(deals) {
      return deals.slice().sort((a, b) => (
        b.calculatedData.totalAnnuallyBillPrice - a.calculatedData.totalAnnuallyBillPrice
      ));
    },
    showFilterTableModal() {
      this.filterTableModalIsVisible = true;
      const bodyElement = document.getElementsByTagName('body')[0];
      bodyElement.style.overflow = 'hidden';
    },
    hideFilterTableModal(val) {
      this.filterTableModalIsVisible = val;
      const bodyElement = document.getElementsByTagName('body')[0];
      bodyElement.style.overflow = 'auto';
    },
  },
};
</script>

<style scoped lang="scss">
.DealsPage__main {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.DealsPage__sortBy {
  width: 170px;
  margin-top: 10px;
  margin-bottom: 15px;
  margin-left: auto; // this will move item to the right
}
/deep/ .Deals .Deal {
  max-width: 350px;
}
.FilterTableModalToggler {
  position: fixed;
  bottom: 15px;
  left: 15px;
  @include z-index(navigationDrawerToggler);
}
@include media-md() {
  /deep/ .Deals .Deal {
    max-width: none;
  }
}
@include media-lg() {
  .DealsPage__main {
    max-width: 720px;
  }
}
@include media-xl() {
  .DealsPage__main {
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
